import React, { useState, useEffect } from 'react'
import axios from 'axios';
import FormTip from '../../commons/form_tip';
import {getCsrfToken} from '../../commons/authenticityToken';

const Index = (props) => {
    axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();
    // ユーザー区分
    const is_general_user = props.current_m_user_user_kbn === "reader" ? true : false 
    
    // テンプレート
    const [templates, setTemplates] = useState([]);
    const [searchName, setSearchName] = useState("");
    const [searchTemplateKbn, setSearchTemplateKbn]  = useState(["20", "30"]);

    // 削除対象テンプレート
    const [deleteTemplate, setDeleteTemplate] = useState({id: 0, name: ""});

    // 削除対象テンプレート
    const [copyTemplate, setCopyTemplate] = useState({id: 0, name: ""});

    // メッセージエリア
    const [infoMessage, setInfoMessage] = useState("");
    
    // 初期ロード
    useEffect(() =>{
        axios.get(
            '/api/internal/templates/search_templates', { params: { name: searchName, template_kbn: searchTemplateKbn}}
        ).then(function (response) {
            setTemplates(response.data.templates);
            }
        ).catch(error => {
            alert(error.response.data.message);
        }
        ); 
    }, [])

    function searchTemplates(){
        axios.get(
            '/api/internal/templates/search_templates', { params: { name: searchName, template_kbn: searchTemplateKbn}}
        ).then(function (response) {
            setTemplates(response.data.templates);
            }
        ).catch(error => {
            alert(error.response.data.message);
        }); 
    }

    function onClickCopyButton(mode){
        axios.post(
            '/api/internal/templates/copy', { id: copyTemplate.id, mode: mode}
        ).then(function (response) {
            setCopyTemplate({id: 0, name: ""});
            setTemplates([...templates, ...response.data.templates]);
            setInfoMessage(response.data.message);
            }
        ).catch(error => {
            alert(error.response.data.message);
            setCopyTemplate({id: 0, name: ""});
        });
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
    }

    function onClickDeleteButton(){
        setInfoMessage("");
        axios.delete(
            '/api/internal/templates/destroy', {
                data: { id: deleteTemplate.id }
            })
            .then(function (response) {
                setTemplates(
                    templates.filter(function(template){
                        return template.id !== deleteTemplate.id
                    })
                ) ;
                setDeleteTemplate({id: 0, name: ""});
                setInfoMessage(response.data.message);
            })
            .catch(error => {
                alert(error.response.data.message)
            }
        ); 
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
    }

    // チェックボックス更新
    function changeTemplateKbn(target) {
        if (target.checked){
            setSearchTemplateKbn([...searchTemplateKbn, target.value]);
        }else{
            setSearchTemplateKbn(searchTemplateKbn.filter(value => value !== target.value));
        }
    }

    return(
        <>
            { infoMessage &&
                <div className="alert fade in alert-success ">
                    <button type="button" className="close" data-dismiss="alert">×</button>
                    {infoMessage}
                </div>
            }
            <h3>先確認アンケート一覧</h3>
            {/* 先確認アンケート一覧 */}
            <div id="template_search_area" className="panel panel-success">
                <div className="panel-heading">検索エリア</div>
                <div className="panel-body">
                    <div className="row">
                        <div className="form-group col-md-6 col-xs-12">
                            <FormTip description="対象者を決めて作成する質問セット">
                                <label >先確認アンケート名</label>
                            </FormTip>
                            <input 
                                type="text" 
                                name="search_name"
                                id="search_name"
                                className="form-control col-lg-1" 
                                placeholder="検索したい内容を入力してください"
                                onChange={(e) => setSearchName(e.target.value)}
                            />
                        </div>
                        <div className="form-group col-md-6"/>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-6 col-xs-12">
                            <div>
                                <label>アンケート区分</label>
                            </div>
                            <div className="col-md-4 col-xs-4">
                                <input 
                                    type="checkbox" 
                                    name="search_template_kbn"
                                    id="search_template_kbn_20"
                                    value={20}
                                    defaultChecked={searchTemplateKbn.includes("20")}
                                    onChange={(e) => changeTemplateKbn(e.target)}
                                />
                                <label htmlFor="search_template_kbn_20">新患用</label>
                            </div>

                            <div className="col-md-4 col-xs-4">
                                <input 
                                    type="checkbox" 
                                    name="search_template_kbn"
                                    id="search_template_kbn_30"
                                    value={30}
                                    defaultChecked={searchTemplateKbn.includes("30")}
                                    onChange={(e) => changeTemplateKbn(e.target)}
                                />
                                <label htmlFor="search_template_kbn_30">再来用</label>
                            </div>
                        </div>
                        <div className="form-group col-md-6 col-xs-12 mt10 text-right">
                            <input type="button" name="button_search" value="検索" className="btn btn-lg btn-primary" onClick={() => searchTemplates()}/>
                        </div>
                    </div>
                </div> 
            </div>
            {/* テンプレート表示設定ボタン */}
            <div className="actions mt40 text-right va_middle">
                <button className="btn btn-primary ml5" onClick={ ()=> location.href="/template_owners/display_settings"} disabled={is_general_user}>アンケート表示設定</button>
            </div>
            
            <div className="col-md-12 col-xs-12">
                <h3 className="red">管理者以外使用しないでください。<br/>アンケートを表示するには店舗毎にアンケート表示設定をしてください。<br/>※ 新規追加・変更・コピー・削除を行うと、全店舗に反映されます。</h3>
            </div>
            {/* 表示エリア */}
            <div className="table-responsive">
                <table id="notice_table" className="table table-bordered">
                    <thead>
                    <tr className="success">
                        <th scope="col" className="text-center col-md-3 col-sm-3 col-xs-3">アンケート名</th>
                        <th scope="col" className="text-center col-md-4 col-sm-4 col-xs-4">説明</th>
                        <th scope="col" className="text-center col-md-1 col-sm-1 col-xs-1">新患／再来</th>
                        <th scope="col" className="text-center col-md-1 col-sm-1 col-xs-1">カテゴリ数</th>
                        <th scope="col" className="text-center col-md-1 col-sm-1 col-xs-1"></th>
                        <th scope="col" className="text-center col-md-1 col-sm-1 col-xs-1"></th>
                        <th scope="col" className="text-center col-md-1 col-sm-1 col-xs-1"></th>
                    </tr>
                    </thead>
                    <tbody>
                        { templates.map((template) =>
                        <>
                            <tr>
                                <td>{template.name}</td>
                                <td>{template.description}</td>
                                <td>{template.kbn_name}</td>
                                <td>{template.part_group_count}</td>
                                {   template.template_kbn === 20 ?
                                    <td className="text-center">    
                                        <button className="btn btn-primary" data-toggle="modal" data-target="#template_copy_modal" 
                                            onClick={() => setCopyTemplate(template)}
                                            disabled={is_general_user}
                                        >コピー</button>
                                    </td> :
                                    <td/>
                                }
                                {/* 所属企業以外は、編集・削除は非表示 */}
                                { props.current_m_company_id === template.m_company_id ?
                                <>
                                    <td className="text-center">
                                        <button className="btn btn-primary" onClick={()=> location.href="/templates/edit?id=" + template.id} disabled={is_general_user}>編集</button>
                                    </td>
                                    <td className="text-center">
                                        <button className="btn btn-danger" data-toggle="modal" data-target="#template_delete_modal" onClick={() => setDeleteTemplate(template)}  disabled={is_general_user}>削除</button>
                                    </td>
                                </>
                                :
                                <>
                                    <td className="text-center"/>
                                    <td className="text-center"/>
                                </>
                                }
                            </tr>
                        </>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="actions mt40 text-center va_middle">
                <button className="btn btn-primary ml5" onClick={ ()=> location.href="/templates/new"} disabled={is_general_user}>アンケート登録</button>
                <button className="btn btn-primary ml5" data-toggle="modal" data-target="#template_commons_copy_modal" disabled={is_general_user}>共通アンケートをすべてコピー</button>
            </div>

            {/* コピーモーダル */}
            <div className="modal fade" data-backdrop="static" id="template_copy_modal">
                <div className="sw-modal-content">
                <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
                    <div className="sw-modal-icon-question sw-modal-icon">?</div>
                    <h2>コピーします</h2>
                    <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
                    以下のアンケート情報をコピーします。<br />
                    よろしいですか？<br />
                    【{copyTemplate && copyTemplate.name}】<br/>
                    </div>
                    <a type="button"
                        className="sw-modal-btn"
                        style={{ backgroundColor: '#3071a9', textDecoration: 'none'}}
                        data-dismiss="modal"
                        data-toggle="modal"
                        data-target="#mode_conf"
                    >
                    コピーする
                    </a>
                    <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
                </div>
                </div>
            </div>

            <div className="modal fade" data-backdrop="static" id="mode_conf">
                <div className="sw-modal-content">
                    <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
                        <div className="sw-modal-icon-question sw-modal-icon">?</div>
                        <h2>コピーします</h2>
                        <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
                        カテゴリ・質問情報もコピーしますか？<br />
                        </div>
                        <a type="button"
                            className="sw-modal-btn"
                            style={{ backgroundColor: '#3071a9', textDecoration: 'none'}}
                            data-dismiss="modal"
                            onClick={() => onClickCopyButton(1)}
                        >
                        する
                        </a>
                        <a type="button"
                            className="sw-modal-btn"
                            style={{ backgroundColor: '#3071a9', textDecoration: 'none'}}
                            data-dismiss="modal"
                            onClick={() => onClickCopyButton(2)}
                        >
                        しない
                        </a>
                    </div>
                    </div>
            </div>


            {/* 削除モーダル */}
            <div className="modal fade" data-backdrop="static" id="template_delete_modal">
                <div className="sw-modal-content">
                <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
                    <div className="sw-modal-icon-question sw-modal-icon">?</div>
                    <h2>削除します</h2>
                    <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
                    以下のアンケート情報を削除します。<br />
                    よろしいですか？<br />
                    【{deleteTemplate && deleteTemplate.name}】<br/>
                    </div>
                    <a type="button"
                        className="sw-modal-btn"
                        style={{ backgroundColor: 'red', textDecoration: 'none'}}
                        data-dismiss="modal"
                        onClick={() => onClickDeleteButton()}
                    >
                    削除する
                    </a>
                    <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
                </div>
                </div>
            </div>
            {/* コピーモーダル */}
            <div className="modal fade" data-backdrop="static" id="template_commons_copy_modal">
                <div className="sw-modal-content">
                    <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
                        <div className="sw-modal-icon-question sw-modal-icon">?</div>
                        <h2>コピーします</h2>
                        <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
                        すべての共通アンケート情報をコピーします。<br />
                        よろしいですか？<br />
                        </div>
                        <a type="button"
                            className="sw-modal-btn"
                            style={{ backgroundColor: '#3071a9', textDecoration: 'none'}}
                            data-dismiss="modal"
                            onClick={() => onClickCopyButton(3)}
                        >
                        コピーする
                        </a>
                        <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
                    </div>
                    </div>
            </div>

        </>
    )
}
export default Index;